export default __webpack_public_path__ + "static/media/Fibonacci Lab.cb8e4350.png";